import { render, staticRenderFns } from "./WidthWrapper.vue?vue&type=template&id=356b38c9&scoped=true&"
import script from "./WidthWrapper.vue?vue&type=script&lang=js&"
export * from "./WidthWrapper.vue?vue&type=script&lang=js&"
import style0 from "./WidthWrapper.vue?vue&type=style&index=0&id=356b38c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356b38c9",
  null
  
)

export default component.exports